import { Component, NgZone, OnInit } from '@angular/core';
import { TreatmentService } from 'src/app/services/treatment.service';
import { PatientService } from 'src/app/services/patient.service';

declare var Ext: any;

@Component({
  selector: 'app-medication-widget',
  templateUrl: './medication-widget.component.html',
  styleUrls: ['./medication-widget.component.scss']
})
export class MedicationWidgetComponent implements OnInit {

  constructor(private patient: PatientService, private ngZone: NgZone,
              public medicationservice: TreatmentService) { }

  ngOnInit(): void {
  }

  newTreatment(): void {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const patient = new Ext.CNPatient(this.patient.patient.id);
        patient.on('itemLoaded', (item) => {
          const prescriptionwindow = new Ext.CNPrescriptionWindow({ patient: item });
          prescriptionwindow.show();
          prescriptionwindow.on('medicationAdded', (treatment) => {
            setTimeout(() => {
              this.reload();
            });
          });
        });
      });
    });
  }

  reload() {
    this.ngZone.run(() => {
      this.medicationservice.reloadAllSubjects();
    });
  }

}
